/* eslint-disable import/prefer-default-export */
/* eslint-disable eol-last */
export const MODAL_LOGOUT_OPEN = 'MODAL_LOGOUT_OPEN';
export const MODAL_LOGOUT_CLOSE = 'MODAL_LOGOUT_CLOSE';